import Airtable from "airtable";

const apiKey = process.env.REACT_APP_AIRTABLE_API_KEY;
const baseId = "app5qz4J5oQ7bqTUo";

if (!apiKey) {
    throw new Error("Missing Airtable API key. Set REACT_APP_AIRTABLE_API_KEY in .env file.");
}

const base = new Airtable({ apiKey }).base(baseId);

export const fetchLayoffsByYear = async (year) => {
    return new Promise((resolve, reject) => {
        let totalKilled = 0;
        let totalInjured = 0;
        let totalAttacks = 0;

        base("tblW3b466o9ISMeEF")
            .select({
                filterByFormula: `YEAR(DATETIME_PARSE({Date}, 'YYYY-MM-DD')) = ${year}`,
            })
            .eachPage(
                (records, fetchNextPage) => {
                    totalAttacks += records.length;

                    records.forEach((record) => {
                        totalKilled += record.fields["Killed"] || 0;
                        totalInjured += record.fields["Injured"] || 0;
                    });

                    fetchNextPage();
                },
                (err) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve({
                            totalKilled,
                            totalInjured,
                            totalAttacks,
                        });
                    }
                }
            );
    });
};